import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  Renderer2,
  signal,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { take } from 'rxjs';

import { AuthService } from 'src/app/core/services/auth';

@Component({
  templateUrl: './impersonation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatProgressSpinnerModule, RouterLink],
})
export class ImpersonationComponent implements OnInit {
  title = 'MyPortal: Impersonate';

  readonly token = signal('');

  readonly hasError = signal(false);

  private readonly authService = inject(AuthService);

  private readonly route = inject(ActivatedRoute);

  private readonly router = inject(Router);

  private readonly renderer = inject(Renderer2);

  ngOnInit(): void {
    this.authService.clearCache();
    this.token.set(this.route.snapshot.queryParamMap.get('token') ?? '');
    this.impersonate(this.token());
  }

  private focusError(): void {
    setTimeout(() => {
      try {
        this.renderer.selectRootElement('#impersonate-error').focus();
      } catch {
        // Element not found or already focused
      }
    });
  }

  impersonate(token: string): void {
    if (!token) {
      this.hasError.set(true);
      this.focusError();
      return;
    }

    this.authService
      .impersonate(token)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.router.navigate(['/']);
        },
        error: () => {
          this.hasError.set(true);
          this.focusError();
        },
      });
  }
}
